import { Box, makeStyles } from '@material-ui/core';

import { Icon } from '@/components/shared/components/Icon';
import { useAddressContext } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/contexts/AddressContext';
import { useAddressFormFields } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/hooks/useAddressFormFields';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';

interface AddressPreviewProps {
  subFieldName: string;
  label?: string;
  placeholder?: string;
  fieldVariant?: FieldVariant;
}

export const AddressPreview = ({
  subFieldName,
  label,
  placeholder,
  fieldVariant = FieldVariant.form,
}: AddressPreviewProps) => {
  const { fieldNamesPrefix, setOpenedDialog } = useAddressContext();
  const { initializeDialog } = useAddressFormFields();

  const openAddressDialog = () => {
    initializeDialog();
    setOpenedDialog(true);
  };

  const name = `${fieldNamesPrefix}.${subFieldName}`;
  const getAddressPreviewStyles = makeStyles(addressPreviewStyles);
  const addressPreviewClasses = getAddressPreviewStyles();

  return (
    <TextFormField
      name={name}
      label={label}
      placeholder={placeholder}
      fieldVariant={fieldVariant}
      classes={addressPreviewClasses}
      InputProps={{
        endAdornment: <Button />,
        style: {
          cursor: 'pointer',
        },
        onClick: openAddressDialog,
      }}
      inputProps={{
        disabled: true,
        style: {
          paddingRight: '80px',
          minWidth: 'calc(100% - 80px)',
          cursor: 'pointer',
          pointerEvents: 'none',
        },
      }}
    />
  );
};

const addressPreviewStyles = {
  root: {
    '&:hover .MuiButton-root': {
      backgroundColor: 'rgba(75, 83, 84, 0.04)',
    },
  },
};

export const Button = () => {
  return (
    <StandardButton
      size="small"
      variant="text"
      color="default"
      style={{
        position: 'relative',
        left: '6px',
        top: '3px',
        pointerEvents: 'all',
        paddingInline: '8px',
      }}
    >
      <Box display={'flex'} gridGap={'6px'} alignItems={'center'}>
        <Text tId={'EDIT'} />
        <Icon size={16}>edit</Icon>
      </Box>
    </StandardButton>
  );
};
